exports = module.exports = require("../../../../landing-page/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@-webkit-keyframes fade-in {\n  0% {\n      opacity: 0;\n  }\n  50% {\n      opacity: 0;\n  }\n  100% {\n      opacity: 1;\n  }\n}\n\n@keyframes fade-in {\n  0% {\n      opacity: 0;\n  }\n  50% {\n      opacity: 0;\n  }\n  100% {\n      opacity: 1;\n  }\n}\n\n.fade-in {\n  -webkit-animation: fade-in 2s;\n  -moz-animation: fade-in 2s;\n  -o-animation: fade-in 2s;\n  -ms-animation: fade-in 2s;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/alextaxiera/source/farmhand-server/client/landing-page/~/css-loader!/Users/alextaxiera/source/farmhand-server/client/landing-page/~/postcss-loader/lib?{"plugins":[null]}!/Users/alextaxiera/source/farmhand-server/client/dashboard/~/react-spinkit/css/fade-in.css
// module id = ../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/lib/index.js?{"plugins":[null]}!../../../dashboard/node_modules/react-spinkit/css/fade-in.css
// module chunks = 1